import React from 'react'
import clsx from 'clsx'
import useProgressStyles from './useProgressStyles'
import { CircularProgress } from '@material-ui/core'

export default function ButtonProgress({ className, loading, ...props }) {
  const classes = useProgressStyles()
  return Boolean(loading) && <CircularProgress size={24} className={clsx`${classes.buttonProgress}${className}`} {...props} />
}